import { version } from '../../package.json'

export const REACT_APP_NAME = import.meta.env.VITE_NAME as string
export const REACT_APP_ENV = import.meta.env.VITE_ENV as string
export const REACT_APP_VERSION = version

export const REACT_APP_ENABLE_V2_SIGN_OUT =
  import.meta.env.VITE_ENABLE_V2_SIGN_OUT === 'true'

export const REACT_APP_FIREBASE_AUTH_API_KEY = import.meta.env
  .VITE_FIREBASE_AUTH_API_KEY as string
export const REACT_APP_FIREBASE_AUTH_DOMAIN = import.meta.env
  .VITE_FIREBASE_AUTH_DOMAIN as string
export const REACT_APP_FIREBASE_AUTH_PROJECT_ID = import.meta.env
  .VITE_FIREBASE_AUTH_PROJECT_ID as string
export const REACT_APP_FIREBASE_PDF_STORAGE_BUCKET = import.meta.env
  .VITE_FIREBASE_PDF_STORAGE_BUCKET as string

export const REACT_APP_FIREBASE_API_KEY = import.meta.env
  .VITE_FIREBASE_API_KEY as string
export const REACT_APP_FIREBASE_PROJECT_ID = import.meta.env
  .VITE_FIREBASE_PROJECT_ID as string
export const REACT_APP_FIREBASE_APP_ID = import.meta.env
  .VITE_FIREBASE_APP_ID as string
export const REACT_APP_FIREBASE_MEASUREMENT_ID = import.meta.env
  .VITE_FIREBASE_MEASUREMENT_ID as string

export const REACT_APP_SITE_API_URL = import.meta.env
  .VITE_SITE_API_URL as string
export const REACT_APP_CORE_API_URL = import.meta.env
  .VITE_CORE_API_URL as string
export const REACT_APP_LADISLAS_API_URL = import.meta.env
  .VITE_LADISLAS_API_URL as string
export const REACT_APP_MERCHANT_BFF_API_URL = import.meta.env
  .VITE_MERCHANT_BFF_API_URL as string
export const REACT_APP_SUPPLIER_BFF_API_URL = import.meta.env
  .VITE_SUPPLIER_BFF_API_URL as string
export const REACT_APP_CHECKOUT_BFF_API_URL = import.meta.env
  .VITE_CHECKOUT_BFF_API_URL as string
export const REACT_APP_ANALYTICS_API = import.meta.env
  .VITE_ANALYTICS_API as string
export const REACT_APP_AUTH_API_URL = import.meta.env
  .VITE_AUTH_API_URL as string
export const REACT_APP_SINGLE_PLAYER_API_URL = import.meta.env
  .VITE_SINGLE_PLAYER_API_URL as string

export const REACT_APP_EXPERIMENTS = import.meta.env.VITE_EXPERIMENTS as string
export const REACT_APP_HOTJAR = import.meta.env.VITE_HOTJAR as string
export const REACT_APP_SENTRY = import.meta.env.VITE_SENTRY as string
export const REACT_APP_MIXPANEL_SUPPLIER = import.meta.env
  .VITE_MIXPANEL_SUPPLIER as string
export const REACT_APP_MIXPANEL_MERCHANT = import.meta.env
  .VITE_MIXPANEL_MERCHANT as string
export const REACT_APP_UNICO_ACCESS_FILE = import.meta.env
  .VITE_UNICO_ACCESS_FILE as string

export const NODE_ENV = process.env.NODE_ENV as string
export const PUBLIC_URL = import.meta.env.VITE_SITE_URL as string
export const REACT_APP_CHECKOUT_APP = import.meta.env
  .VITE_CHECKOUT_APP as string

export const REACT_APP_SUPPLIER_ID_DEFAULT = import.meta.env
  .VITE_SUPPLIER_ID_DEFAULT as string

export const REACT_APP_POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string
export const REACT_APP_POSTHOG_HOST = import.meta.env
  .VITE_POSTHOG_HOST as string

export const REACT_APP_GOOGLE_MAPS_API_KEY = import.meta.env
  .VITE_GOOGLE_MAPS_API_KEY as string

export const VITE_ZENDESK_KEY = import.meta.env.VITE_ZENDESK_KEY as string
